import DesktopFooter from './DesktopFooter'
import MobileFooter from './MobileFooter'
import { useIsMobile } from 'src/utils'

const Footer = () => {
  const isMobile = useIsMobile()

  return isMobile ? <MobileFooter /> : <DesktopFooter />
}

export default Footer
